import React, { useEffect, useState } from 'react';
import type { ReactSwitchProps } from 'react-switch';
import ReactSwitch from 'react-switch';
import Translator, { Language } from '../../services/translate-factory';
import * as Constants from '../../store/constants/all';
import './switch.css';

const T = Translator.create();

const Switch: React.FC<ReactSwitchProps> = (props) => {
  const [isRTL, setIsRTL] = useState(false);

  const updateRTLState = () => {
    const htmlDir = document.documentElement.getAttribute('dir');
    setIsRTL(htmlDir === 'rtl');
  };

  useEffect(() => {
    // Set initial RTL state
    updateRTLState();

    // Listen for language changes
    const langChanged = () => {
      setTimeout(() => {
        updateRTLState();
      }, 100);
    };

    T.addListener(Constants.gen.CORE_CHANGE_LANGUAGE, langChanged);

    // Cleanup listener on unmount
    return () => {
      T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, langChanged);
    };
  }, []);

  return (
    <div
      className={`custom-switch-container ${isRTL ? 'rtl' : 'ltr'}`}
      style={{
        direction: isRTL ? 'rtl' : 'ltr',
        display: 'inline-block',
      }}
    >
      <ReactSwitch
        handleDiameter={20} // Varsayılan handle boyutu
        height={25} // Varsayılan yükseklik
        width={40} // Varsayılan genişlik
        offColor="#E8ECED" // Kapalı durum rengi
        onColor="#358730" // Açık durum rengi
        checkedIcon={false} // Tik ikonunu kaldır
        uncheckedIcon={false} // Çarpı ikonunu kaldır
        {...props} // Kullanıcının geçtiği diğer tüm proplar
      />
    </div>
  );
};

export default Switch;
